import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";
import { NavigationHelperService } from "../../common/services/navigation-helper.service";
import {
  Patient,
  PatientListItem,
} from "../../common/interfaces/patient.interface";
import { CommonModule } from "@angular/common";
import { UserService } from "../../common/services/user.service";
import { StorageService } from "src/app/common/services/storage.service";
import { distinctUntilChanged } from "rxjs";
import { SecurityFeatureUtility } from "src/app/common/services/security-feature.utility";
import { Features } from "src/app/common/enums/features.enum";
import { AppConstants } from "src/app/common/constants/app-constants";
import { BiDashboardConstants } from "src/app/common/constants/bi-dashboard.constants";
import { appRoute } from "src/app/app-route.constants";

import { environment } from "environment";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
})
export class SidenavComponent implements OnInit {
  currentRoute = this.router.url;
  isPatientsActive = false;
  patient: PatientListItem | null | Patient = null;
  selectedFacilityId = "";
  user: any = null;
  isPhysician: boolean = false;
  hasCoSignPermission: boolean = false;
  hasBiToolAccess: boolean = false;
  hasCloseOutAccess : boolean = false;
  biDashboardConstants = BiDashboardConstants;
  appRoutes = appRoute;
  enableNewReactApp = environment.enableNewReactApp;
  private securityGroupSubscription: any;

  constructor(
    private navigationHelperService: NavigationHelperService,
    private router: Router,
    private userService: UserService,
    private storageService: StorageService,
    private securityFeatureUtility: SecurityFeatureUtility
  ) {}

  ngOnInit() {
    this.checkCoSignPermission();
    this.securityGroupSubscription = this.storageService.securityGroupChanged$
      .pipe()
      .subscribe((val: boolean) => {
        this.checkCoSignPermission();
        this.checkBiToolAccess();
        this.checkCloseOutAccess();
      });
    this.user = this.userService.getCurrentUser();
    this.storageService.isUserPhysician.subscribe((val) => {
      this.isPhysician = val;
    });
    this.storageService.isSelectedFacility
      .pipe(distinctUntilChanged())
      .subscribe((facilityId) => {
        this.selectedFacilityId = facilityId;
      });

    this.navigationHelperService.selectedPatient$.subscribe((patient) => {
      this.patient = patient;
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.isPatientsActive = !!this.currentRoute.match(
          /\/patient\/[a-zA-Z0-9]*$/
        );
      }
    });
  }

  checkCoSignPermission() {
    this.hasCoSignPermission =
      this.securityFeatureUtility.getSecurityFeature(Features.CO_SIGN, false)
        ?.featureaccess !== "N";
  }

  checkBiToolAccess(){
    this.hasBiToolAccess =
      this.securityFeatureUtility.getSecurityFeature(Features.DASHBOARD, false)
        ?.featureaccess !== AppConstants.none;
  }

  checkCloseOutAccess(){
    this.hasCloseOutAccess =
      this.securityFeatureUtility.getSecurityFeature(Features.CLOSE_OUT, false)
        ?.featureaccess !== AppConstants.none;
  }
}
